const FACEBOOK = "https://www.facebook.com/vahakindia";
const LINKEDIN = "https://www.linkedin.com/company/vahakindia/";
const YOUTUBE = "https://www.youtube.com/channel/UC58fbLa8WOUEVwxg042C6RA";
const INSTAGRAM = "https://www.instagram.com/vahakindia/";
const TWITTER = "https://twitter.com/VahakIndia";
const TWITTER_HANDLE = "@VahakIndia";
const COMPANY_SOCIAL_MEDIA_CHANNELS = {
    FACEBOOK,
    LINKEDIN,
    YOUTUBE,
    INSTAGRAM,
    TWITTER
};

export { COMPANY_SOCIAL_MEDIA_CHANNELS, FACEBOOK, INSTAGRAM, LINKEDIN, TWITTER, TWITTER_HANDLE, YOUTUBE };
//# sourceMappingURL=socialMediaLinks.js.map
